var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Decoration_Type, FontSizeData_fontType } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { EmptyDecoration } from "./empty-decoration";
class FontSizeDecoration {
  constructor(customStyle) {
    __publicField(this, "type", Decoration_Type.FONT_SIZE);
    __publicField(this, "customStyle");
    this.customStyle = customStyle;
  }
  static of(decoration) {
    if (decoration.type !== Decoration_Type.FONT_SIZE) {
      throw new TypeError(`invalid decoration initializer ${decoration}`);
    }
    const value = decoration.fontSizeData?.value;
    const unit = decoration.fontSizeData?.unit?.toLocaleLowerCase();
    const customStyle = value ? {
      fontSize: `${value}${unit}`
    } : {};
    return new FontSizeDecoration(customStyle);
  }
  getDecoration() {
    return {
      type: this.type,
      fontSizeData: {
        value: parseInt(this.customStyle.fontSize),
        unit: FontSizeData_fontType.PX
      }
    };
  }
  static fromCustomStyle(customStyle) {
    return new FontSizeDecoration(customStyle);
  }
  fromCustomStyle(customStyle) {
    return FontSizeDecoration.fromCustomStyle(customStyle);
  }
  toCustomStyle() {
    return this.customStyle;
  }
  overrideWith(decoration) {
    if (!(decoration instanceof FontSizeDecoration || decoration instanceof EmptyDecoration)) {
      throw new TypeError(`invalid merge decoration ${decoration}`);
    }
    const customStyle = { ...this.customStyle, ...decoration.toCustomStyle() };
    return new FontSizeDecoration(customStyle);
  }
}
export {
  FontSizeDecoration
};
//# sourceMappingURL=font-size-decoration.js.map
